import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rePublishApp } from 'api/appManager';
import { LIST_APP_DETAIL_QUERY } from 'constants/QueryString';

const useRePublishApp = () => {
  const queryClient = useQueryClient();

  const {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
  } = useMutation({
    mutationFn: rePublishApp,
    onSuccess: (data) => {
      queryClient.invalidateQueries([LIST_APP_DETAIL_QUERY, data.Id]);
    },
    onError: (error) => {
      console.error('Error creating user:', error);
    },
  });
  return {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
  };
};

export default useRePublishApp;
